import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { gql, useMutation } from '@apollo/client';

const GET_FOLLOWER_USERS = gql`
  mutation Authorize($token: String!) {
    authorize(
      input: {token: $token}
    ) {
      user {
        followers {
          uuid
          username
          display_name
        }
      }
    }
  }
`;

function FollowersSection({ token }) {
  const [followerUsers, setFollowerUsers] = useState([]);

  const [fetchFollowers] = useMutation(GET_FOLLOWER_USERS, {
    variables: { token },
    onCompleted: (d) => {
      setFollowerUsers(d.authorize.user.followers);
    }
  });

  useEffect(() => {
    fetchFollowers().finally();
  }, []);

  const hasFollowerUsers = followerUsers.length || -1 > 0;

  return (
    <div>
      <div>
        <h2 className="py-3">Followers</h2>
      </div>
      {!hasFollowerUsers ? (
        <div>No followers</div>
      ) : (
        <table className="table table-sm">
          <tbody>
          {followerUsers?.map(({ uuid, display_name: displayName }) => {
            return (
              <tr key={`follower-${uuid}`}>
                <td>{displayName}</td>
              </tr>
            );
          })}
          </tbody>
        </table>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.commentToken,
  };
};

FollowersSection.propTypes = {
  token: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(FollowersSection);
